import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { Portlet } from '@core/js/components/system/Portlet';
import { NavigationBar } from '@core/js/components/main/NavigationBar';
import { useAppSelector, useDeviceSelector } from '@core/js/store/hooks';

import * as hooks from '@core/js/components/system/Page/components/Layout/hooks';
import { withPageEvent } from '@core/js/components/system/Page/hocs';
import { LayoutLoader } from '@core/js/components/system/Page/components/LayoutLoader';

import style from './Layout.scss';

export const LayoutBare = ({ page, isLoading, isPageInPopup }) => {
    const formFactor = useDeviceSelector(prop('formFactor'));
    const { portlets, pageLayout, friendlyURL } = page;
    const isNavigationBarAvailable = hooks.useIsNavigationBarAvailable(friendlyURL);
    const isAdminLoggedIn = useAppSelector(prop('isAdminLoggedIn'));

    const getLayout = useCallback((layoutItem, isNavigationBar) => {
        const layout = [];
        const rootLayoutClassName = isNavigationBar ? style.rootLayoutWithNavigation : '';

        if (layoutItem.children?.length) {
            layout.push(
                <div
                    id={layoutItem.id}
                    key={layoutItem.id}
                    style={isNavigationBar ? {} : { width: layoutItem.width }}
                    className={`${style[layoutItem.layoutType]} page-layout-${layoutItem.layoutType} ${rootLayoutClassName}`}
                >
                    {layoutItem.children.map(child => getLayout(child))}
                </div>
            );
        } else {
            layout.push(
                <div
                    id={layoutItem.id}
                    key={layoutItem.id}
                    data-column-id={`column-${layoutItem.dropZoneId}`}
                    style={isNavigationBar ? {} : { width: layoutItem.width }}
                    className={`${style.layout} ${layoutItem.customClasses} ${rootLayoutClassName}`}
                >
                    <div
                        id={`layout-column_column-${layoutItem.dropZoneId}`}
                        className={`portlet-dropzone portlet-column-content fn-portlet-container column-${layoutItem.dropZoneId}`}
                    >
                        {portlets
                            .filter(portlet => isAdminLoggedIn || Boolean(portlet.enabledDevices[formFactor]))
                            .filter(portlet => portlet.column === `column-${layoutItem.dropZoneId}` || portlet.column === layoutItem.dropZoneId)
                            .map(portlet => <Portlet key={portlet.reactPortletId} portlet={portlet}/>)}
                    </div>
                </div>
            );
        }

        return layout;
    }, [formFactor, isAdminLoggedIn, portlets]);

    return (
        <div
            id="main-content"
            style={pageLayout.layoutWidth ? { width: pageLayout.layoutWidth } : {}}
            className={`layout-wrapper ${style.layoutWrapper} ${isAdminLoggedIn ? style.admin : ''} ${pageLayout.layoutClasses}`}
    >
            {isNavigationBarAvailable() && <NavigationBar currentPageURL={friendlyURL} />}
            {isLoading
                ? <LayoutLoader isPageInPopup={isPageInPopup} navBarPresent={isNavigationBarAvailable()} /> // TotalCasino Changes
                : getLayout(pageLayout.layouts[0], isNavigationBarAvailable())
            }
        </div>
    );
};

export const Layout = withPageEvent(LayoutBare);
